import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Loading...",
          class: "loading-gif"
        }, null, -1)
      ]))]))
    : _createCommentVNode("", true)
}